// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import store from './store/store'
import Viewer from 'v-viewer'
// import audio from './assets/images/y1479.mp3'
import 'viewerjs/dist/viewer.css'

import VueQuillEditor from 'vue-quill-editor'

// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor, /* { 默认全局 } */)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})
Viewer.setDefaults({
  // title: false,
  // toolbar: false,
  // navbar: false,
  // button: false
})

// Vue.prototype.playAudio = () => {
//   let buttonAudio = document.getElementById('my_audio');
//   buttonAudio.setAttribute('src', audio)
//   buttonAudio.play()
// }
Vue.prototype.$axios = axios;
Vue.config.productionTip = false

Vue.use(ElementUI, { zIndex: 1000 })


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  // to代表将要跳转的路径
  // from代表从哪个路径跳转而来
  // next()是一个函数，表示放行，next('/login')表示强制跳转到login页面
  // if(to.path==='/'){
  //     return next('/login')
  // }
  if (to.path !== '/' && to.path !== '/login' && to.path !== '/reg' && to.path !== '/useragreement' && to.path !== '/jobintro' && to.path !== '/privateagree') {
    
    if (window.sessionStorage.token) {

    }
    else {
      return next('/login')
    }
  }
//   if (to.path === '/about') {
//     if (window.sessionStorage.token) {
      
//     }
//     else {
//       return next('/login')
//     }
    
// }
//   if (to.path === '/friend') {
//     if (window.sessionStorage.token) {
//     }
//     else {
//       return next('/login')
//     }
  
// }
//   if (to.path === '/moments') {
//     if (window.sessionStorage.token) {

//     }
//     else {
//        return next('/login')
//     }
 
// }
//   if (to.path === '/job') {
//     if (window.sessionStorage.token) {

//     }
//     else {
//       return next('/login')
//     }
//   }
//   if (to.path === '/price') {
//     if (window.sessionStorage.token) {

//     }
//     else {
//       return next('/login')
//     }
//   }
  // if (to.path === '/') {
  //   if (window.sessionStorage.token) {

  //   }
  //   else {
  //     return next('/login')
  //   }
  // }

  // const Token = window.sessionStorage.getItem('token')
  // if(!Token){
  //     return next()
  // }
  next()

  })
// var websocket = null; 
// var userId = JSON.parse(
//   sessionStorage.getItem("userinfo_Data")
// ).id
// //判断当前浏览器是否支持WebSocket，是则创建WebSocket
// if ('WebSocket' in window) {
//   websocket = new WebSocket("ws://124.221.125.59:9701/jeecg-boot/websocketRingStar/" + userId);
 
// } else {
//   alert('当前浏览器 Not support websocket')
// }

// //连接发生错误的回调方法
// websocket.onerror = function () {
//   console.log("WebSocket连接发生错误");
// };
// //连接成功建立的回调方法
// websocket.onopen = function () {
//   console.log("WebSocket连接成功");
// }
// //接收到消息的回调方法
// websocket.onmessage = function (event) {
//   console.log(event.data);
// }
// //连接关闭的回调方法
// websocket.onclose = function () {
//   console.log("WebSocket连接关闭");
// }

// //关闭WebSocket连接
// function closeWebSocket() {
//   websocket.close();
// }
// //发送消息
// function send() {
//   var message = document.getElementById('text').value;
//   websocket.send(message);
// }

// //如果websocket连接还没断开就关闭了窗口，后台server端会抛异常。
// //所以增加监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接
// window.onbeforeunload = function () {
//   closeWebSocket();
// }




// WEBPACK FOOTER //
// ./src/main.js